/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Article_CoreInputs */

const en_directory_submit_enrich_stage_article_core = /** @type {(inputs: Directory_Submit_Enrich_Stage_Article_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core article`)
};

const zh_directory_submit_enrich_stage_article_core = /** @type {(inputs: Directory_Submit_Enrich_Stage_Article_CoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成正文`)
};

/**
* | output |
* | --- |
* | "Core article" |
*
* @param {Directory_Submit_Enrich_Stage_Article_CoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_article_core = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Article_CoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Article_CoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_article_core(inputs)
	return zh_directory_submit_enrich_stage_article_core(inputs)
});
export { directory_submit_enrich_stage_article_core as "directory.submit.enrich.stage.article_core" }